import ShelfBackground from 'components/shelf-background'
import styled from 'styled-components'

export const Wrapper = styled(ShelfBackground).attrs(props => ({
  color: props.color
}))`
  padding: 27px 0 1px 0;
  margin-bottom: 68px;
  margin-top: 20px;
  border: 0;
`
